(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["op_landing-zara-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  
  // 1. POPUP LOGIC (MODAL)
  const modal = document.getElementById('z-product-modal');
  const closeBtn = document.querySelector('.z-popup-close');
  
  if(modal) {
    document.querySelectorAll('.trigger-popup').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const titleEl = document.getElementById('modal-title');
        const descEl = document.getElementById('modal-desc');
        const imgEl = document.getElementById('modal-img');
        const priceEl = document.getElementById('modal-price');

        if(titleEl) titleEl.textContent = btn.dataset.title;
        if(descEl) {
           const parser = new DOMParser();
           const doc = parser.parseFromString(btn.dataset.desc, "text/html");
           descEl.innerHTML = doc.body.textContent;
        }
        if(imgEl) imgEl.src = btn.dataset.img;
        if(priceEl) priceEl.textContent = btn.dataset.price;
        
        modal.classList.add('active');
        document.body.style.overflow = 'hidden'; 
      });
    });
    
    const closeModal = () => {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    };
    
    if(closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if(e.target === modal) closeModal();
    });
  }

  // 2. STICKY FOOTER LOGIC
  const stickyFooter = document.getElementById('zara-sticky-footer');
  const shopSection = document.getElementById('shop-grid');
  const modeGeneral = document.getElementById('footer-mode-general');
  const modeCart = document.getElementById('footer-mode-cart');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if(modeGeneral) modeGeneral.classList.remove('active');
        if(modeCart) modeCart.classList.add('active');
      } else {
        if(modeCart) modeCart.classList.remove('active');
        if(modeGeneral) modeGeneral.classList.add('active');
      }
    });
  }, { threshold: 0.1 });
  
  if(shopSection) observer.observe(shopSection);
  if(stickyFooter) setTimeout(() => stickyFooter.classList.add('visible'), 500);

  // 3. CART UPDATE LOGIC
  function updateStickyFooter() {
    fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const count = cart.item_count;
      const totalEuro = cart.total_price / 100;
      
      const sfTotal = document.getElementById('sf-total-price');
      const sfPromo = document.getElementById('sf-promo-msg');
      const sfBtn = modeCart ? modeCart.querySelector('a') : null; 
      
      if (count === 0) {
        if(sfBtn) {
            sfBtn.textContent = "CHOISIS TON PREMIER KIT 👇";
            sfBtn.href = "#shop-grid";
        }
        if(sfTotal) sfTotal.textContent = "0,00 €";
        if(sfPromo) sfPromo.innerHTML = "";
      } else {
        if(sfBtn) {
            sfBtn.textContent = "VALIDER MA COMMANDE";
            sfBtn.href = "/cart";
        }
        
        let displayTotal = totalEuro.toFixed(2) + " €";
        let promoHTML = "";

        if (count === 1) {
          promoHTML = "Ajoute 1 kit = <b>-25% + CADEAU !</b>";
        } else if (count === 2) {
          let discounted = totalEuro * 0.75;
          displayTotal = `<span style="text-decoration:line-through;opacity:0.5;font-size:0.9em;">${totalEuro.toFixed(2)}€</span> ${discounted.toFixed(2)}€`;
          promoHTML = "Guide Offert inclus ! 🔥";
        } else if (count >= 3) {
          let discounted = totalEuro * 0.60;
          displayTotal = `<span style="text-decoration:line-through;opacity:0.5;font-size:0.9em;">${totalEuro.toFixed(2)}€</span> ${discounted.toFixed(2)}€`;
          promoHTML = "-40% Appliqué ! 💥";
        }
        
        if(sfTotal) sfTotal.innerHTML = displayTotal;
        if(sfPromo) sfPromo.innerHTML = promoHTML;
      }
    })
    .catch(e => console.error("Cart error", e));
  }
  
  updateStickyFooter();

  // 4. ADD TO CART (SECURED NO REDIRECT)
  const forms = document.querySelectorAll('.ajax-form');
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      // STOP REDIRECT
      e.preventDefault();
      e.stopPropagation();
      
      const btn = this.querySelector('button');
      const span = btn.querySelector('span');
      const originalText = span ? span.textContent : "AJOUTER";
      
      // Loading State
      btn.classList.add('loading');
      
      const formData = new FormData(this);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Stop Loading
        btn.classList.remove('loading');
        
        if(span) span.textContent = "AJOUTÉ";
        btn.style.background = "#000"; // Stay black or invert as needed
        btn.style.color = "#fff";
        
        // Update Footer State
        updateStickyFooter();
        
        if(modeGeneral) modeGeneral.classList.remove('active');
        if(modeCart) modeCart.classList.add('active');

        // Reset Button Text
        setTimeout(() => {
          if(span) span.textContent = originalText;
          btn.style.background = "";
          btn.style.color = "";
        }, 2000);
      })
      .catch((error) => {
        console.error('Error:', error);
        btn.classList.remove('loading');
      });
      
      return false;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["op_landing-zara"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  
  const stickyFooter = document.getElementById('zara-sticky-footer');
  const shopSection = document.getElementById('shop-grid');
  const modeGeneral = document.getElementById('footer-mode-general');
  const modeCart = document.getElementById('footer-mode-cart');
  
  // 1. INTERSECTION OBSERVER (Toggle Footer Modes)
  // When the user sees the products, show Cart Logic. Otherwise show General CTA.
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        modeGeneral.classList.remove('active');
        modeCart.classList.add('active');
      } else {
        modeCart.classList.remove('active');
        modeGeneral.classList.add('active');
      }
    });
  }, { threshold: 0.1 }); // Trigger when 10% of shop section is visible
  
  if(shopSection) observer.observe(shopSection);
  
  // Scroll Logic to hide/show footer entirely (optional, but requested 'visible' logic)
  // For now, we keep it visible 100% of time on mobile via CSS, but toggle content.
  setTimeout(() => stickyFooter.classList.add('visible'), 500);

  // 2. AJAX CART LOGIC
  function updateStickyFooter() {
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(r => r.json())
    .then(cart => {
      const count = cart.item_count;
      const total = cart.total_price / 100; // in euros
      
      const sfPrices = document.getElementById('sf-prices');
      const sfPromo = document.getElementById('sf-promo-msg');
      const sfText = document.getElementById('sf-text-main');
      
      // Calculate Discount Logic for Display
      let finalPrice = total;
      let discountMsg = "";
      
      if (count === 0) {
        sfText.textContent = "Choisis ton premier kit 👇";
        sfPrices.innerHTML = "";
        sfPromo.textContent = "";
        // Optional: Disable button
      } else if (count === 1) {
        sfText.textContent = "Voir mon panier";
        sfPrices.innerHTML = `(${total.toFixed(2)}€)`;
        sfPromo.innerHTML = "Encore 1 kit pour <b>-25% + CADEAU !</b>";
      } else if (count === 2) {
        sfText.textContent = "Voir mon panier";
        let discounted = total * 0.75; // 25% off
        sfPrices.innerHTML = `<span class="sf-old-price">${total.toFixed(2)}€</span> <span class="sf-new-price">${discounted.toFixed(2)}€</span> <span class="sf-discount-label">-25% 🔥</span>`;
        sfPromo.innerHTML = "Guide Offert inclus dans le colis !";
      } else if (count >= 3) {
        sfText.textContent = "Voir mon panier";
        let discounted = total * 0.60; // 40% off
        sfPrices.innerHTML = `<span class="sf-old-price">${total.toFixed(2)}€</span> <span class="sf-new-price">${discounted.toFixed(2)}€</span> <span class="sf-discount-label">-40% 💥</span>`;
        sfPromo.innerHTML = "Offre Maximale débloquée !";
      }
    });
  }

  // Initial Load
  updateStickyFooter();

  // Handle Add To Cart
  document.querySelectorAll('.ajax-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = this.querySelector('button');
      btn.classList.add('loading');
      
      let formData = new FormData(this);
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        btn.classList.remove('loading');
        // Visual Feedback on button
        const originalText = btn.innerHTML;
        btn.innerText = "AJOUTÉ !";
        btn.style.background = "#fff";
        btn.style.color = "#000";
        
        updateStickyFooter(); // Update the footer numbers
        
        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.style.background = "";
          btn.style.color = "";
        }, 2000);
      })
      .catch(err => {
        console.error(err);
        btn.classList.remove('loading');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["op_products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  
  // --- 1. MODAL LOGIC ---
  const modal = document.getElementById('z-section-modal');
  const overlay = modal;
  const closeBtn = modal.querySelector('.z-popup-close');
  
  // Open Modal
  document.querySelectorAll('.trigger-modal').forEach(card => {
    card.addEventListener('click', (e) => {
      // Si on clique sur le formulaire d'ajout direct, on n'ouvre pas la modal
      if(e.target.closest('.zara-ajax-form')) return;

      e.preventDefault();
      
      // Populate Data
      document.getElementById('z-modal-title').textContent = card.dataset.title;
      document.getElementById('z-modal-price').textContent = card.dataset.price;
      document.getElementById('z-modal-img').src = card.dataset.img;
      document.getElementById('z-modal-variant-id').value = card.dataset.id;
      document.getElementById('z-modal-link').href = card.dataset.url;
      
      // Get Content safely
      const descContent = card.querySelector('.hidden-desc').innerHTML;
      document.getElementById('z-modal-desc').innerHTML = descContent;

      // Show
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  // Close Modal
  const closeModal = () => {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  };
  
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', (e) => {
    if(e.target === overlay) closeModal();
  });
  
  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape' && modal.classList.contains('active')) closeModal();
  });

  // --- 2. UNIVERSAL AJAX ADD TO CART ---
  // Works for both List buttons AND Modal button
  document.body.addEventListener('submit', function(e) {
    if(!e.target.classList.contains('zara-ajax-form')) return;
    
    e.preventDefault();
    const form = e.target;
    const btn = form.querySelector('button');
    const span = btn.querySelector('span');
    const originalText = span ? span.textContent : "AJOUTER";

    if(btn.classList.contains('loading') || btn.classList.contains('disabled')) return;
    
    btn.classList.add('loading');
    
    const formData = new FormData(form);
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(data => {
      btn.classList.remove('loading');
      if(span) span.textContent = "AJOUTÉ !";
      
      // Optionnel : Mettre à jour le compteur du panier si tu as une API de thème
      // updateCartDrawer(); 
      
      setTimeout(() => {
        if(span) span.textContent = originalText;
        // Si c'était dans la modale, on peut la fermer auto ou laisser ouvert
        if(form.id === 'modal-form') closeModal();
      }, 1500);
    })
    .catch(err => {
      console.error(err);
      btn.classList.remove('loading');
      if(span) span.textContent = "ERREUR";
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
